/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var OnlineTrainingOutcome;

(function (OnlineTrainingOutcome) {
  OnlineTrainingOutcome["COMPLETED_SUCCESSFULLY"] = "completed_successfully";
  OnlineTrainingOutcome["ADDITIONAL_TRAINING_REQUIRED"] = "additional_training_required";
  OnlineTrainingOutcome["FOLLOW_UP_REQUIRED"] = "follow_up_required";
  OnlineTrainingOutcome["PORTAL_SUPPORT_REQUIRED"] = "portal_support_required";
  OnlineTrainingOutcome["PRODUCT_SUPPORT_REQUIRED"] = "product_support_required";
  OnlineTrainingOutcome["NO_SHOW"] = "no_show";
  OnlineTrainingOutcome["RESCHEDULED"] = "rescheduled";
  OnlineTrainingOutcome["CANCELLED"] = "cancelled";
})(OnlineTrainingOutcome || (OnlineTrainingOutcome = {}));